export const STALE_TIME = 172800 * 100;
export const STALE_TIME_DAY = 86400 * 100;

export const QUERY_TYPE = {
  SEARCH_SELLERS: 'search_sellers',
  SEARCH_BRANDS: 'search_brands',
};
